import {Button, DatePicker, Divider, Drawer, Form, notification, Pagination, Select} from 'antd';
import {useEffect, useState} from 'react';
import {useForm} from 'antd/es/form/Form';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {notifications, setIsRead} from './notificationsSlice';
import {SearchOutlined} from '@ant-design/icons';
import moment from 'moment';
import {NOTIFICATION_MAIN_FILTER} from './notifications.type';
import NotificationCard from './NotificationCard';
import {debounce} from 'lodash';
import {debounceDelay} from '../../common/constants';
import {batteriesList, clearBatteriesFilters} from '../setup/battery/batteries/batteriesSlice';
import useMQTT from '../../common/useMqtt';

const Notifications = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const state = useAppSelector((state) => state.notifications);
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user.details);
  const [searchForm] = useForm();
  const batteryOptions = useAppSelector((state) => state.batteries.batteries.pageData);

  const [filter, setFilter] = useState<NOTIFICATION_MAIN_FILTER>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleFormSubmit = (values: {battery_id?: number[]; date?: any}) => {
    const payload: NOTIFICATION_MAIN_FILTER = {};

    if (values.date !== undefined && values.date !== null) {
      payload.from = `${values.date[0].format('YYYY/MM/DD HH:mm:ss')}`;
      payload.to = `${values.date[1].format('YYYY/MM/DD HH:mm:ss')}`;
    }
    if (values.battery_id !== undefined && values.battery_id.length > 0) {
      payload.battery_id = values.battery_id;
    }

    if (Object.keys(payload).length > 0) {
      setFilter(payload);
      dispatch(notifications({body: payload, filters: {page_number: 1, page_size: 10}}));
    } else {
      setFilter({});
      dispatch(notifications({filters: {page_number: 1, page_size: 10}}));
    }
  };
  const [message] = useMQTT(`notification/${user.organisationId}/${user.id}`);
  const handleBatteryBouncing = debounce((e) => {
    dispatch(batteriesList({search: e, is_active: true}));
  }, debounceDelay);

  useEffect(() => {
    if (message !== undefined) {
      notification.open({
        message: (
          <>
            <h5>Bid - {message.asset_id}</h5>
            <h5> Event - {message.event[0]}</h5>
            <h5>{`Time - ${new Date(message.event_time)}`}</h5>
          </>
        ),
      });
      dispatch(setIsRead(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  return (
    <Drawer
      title='Notifications'
      placement='right'
      onClose={() => {
        setIsOpen(false);
        dispatch(clearBatteriesFilters());
      }}
      width={650}
      open={isOpen}
    >
      <div>
        <Form layout='inline' name='searchForm' form={searchForm} onFinish={handleFormSubmit}>
          <Form.Item name='battery_id'>
            <Select
              style={{width: '190px'}}
              placeholder='Select battery'
              showArrow
              allowClear
              mode='multiple'
              maxTagCount={1}
              filterOption={false}
              onSearch={(e) => {
                if (e.length > 2) handleBatteryBouncing(e);
              }}
            >
              {batteryOptions.map((x, i) => (
                <Select.Option key={i} value={x.id}>
                  {x.asset_id}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='date'>
            <DatePicker.RangePicker
              showTime
              format='YYYY-MM-DD HH:mm'
              style={{width: '330px'}}
              disabledDate={(current) => current.isAfter(moment().add(0, 'days'))}
            />
          </Form.Item>

          <Button
            icon={<SearchOutlined />}
            type='primary'
            htmlType='submit'
            shape='circle'
          ></Button>
        </Form>
      </div>
      <Divider style={{borderColor: '#00000060', marginBlock: '10px'}} />
      <div style={{height: '700px', overflowY: 'scroll', paddingInline: '5%'}}>
        {state.notifications.pageData.map((x, i) => (
          <NotificationCard data={x} key={i} />
        ))}
      </div>
      <Divider style={{borderColor: '#00000060', marginBlock: '10px'}} />
      <Pagination
        total={state.notifications.totalDataCount}
        current={state.notifications.page_number}
        pageSize={10}
        size='small'
        showSizeChanger={false}
        onChange={(pageNumber) => {
          if (pageNumber !== state.notifications.page_number) {
            dispatch(
              notifications({body: filter, filters: {page_number: pageNumber, page_size: 10}}),
            );
          }
        }}
      />
    </Drawer>
  );
};

export default Notifications;
